import BaseApp from "./BaseApp"
import { WebCamState, ErrorReason } from './Enums';
import PrivacyPriorityScreen from './Screens/PrivacyPriorityScreen';
import QuitTestButton from './Screens/QuitTestButton';
import WaitScreen from './Screens/WaitScreen';
import WebCamAccessScreen from './Screens/WebCamAccessScreen';
import WelcomeScreen from './Screens/WelcomeScreen';

export default class StandaloneApp extends BaseApp {
    constructor() {
        super();
    }

    init() {
        return new Promise(resolve => {
            Realeyesit.EnvironmentalDetectionAPI.start(async environmentCheckResult => {
                const isInitialized = await super.init(environmentCheckResult);

                resolve(isInitialized);
            }, window.jsModuleSettings);
        });
    }

    async run() {
        // cookie consent
        const cookieConsentResult = await this.cookieConsentManager.getCookieConsent();
        if (!cookieConsentResult) {
            this.errorService.cookieConsentDenied();
            return;
        }

        // wait
        const waitScreen = new WaitScreen(this.uiService);
        waitScreen.display();

        // dispatcher run
        const sessionCreated = await this.dispatcher.run();
        if (!sessionCreated) {
            const errorScreen = new ErrorScreen(this.uiService);
            errorScreen.display();

            return;
        }

        this.cookieConsentManager.showCookieConsentReviewBar(this.identityService.identityKey);

        await this.dispatcher.getTestElements();

        new QuitTestButton(this.messageService, this.test).init();

        // welcome

        const welcomeScreen = new WelcomeScreen(this.uiService);

        // TODO: this only ever returns true, the 'quit test' button doesn't return anything here
        if (!(window.jsModuleSettings && window.jsModuleSettings.skippedPages && window.jsModuleSettings.skippedPages.includes("welcome"))) {
            await welcomeScreen.display();
        }

        // TODO: this may be merged with the Welcome screen
        // privacy priority
        const privacyPriorityScreen = new PrivacyPriorityScreen(this.uiService);

        // TODO: this only ever returns true, the 'quit test' button doesn't return anything here
        if (!(window.jsModuleSettings && window.jsModuleSettings.skippedPages && window.jsModuleSettings.skippedPages.includes("privacy"))) {

            await privacyPriorityScreen.display();
        }

        // webcam access
        const webcamAccessScreen = new WebCamAccessScreen(this.sessionService, this.messageService, this.proxyRecorder, this.uiService);
        await webcamAccessScreen.display();

        const webCamAccessState = await this.webcamAccessManager.askWebcamPermissionsWithUI();

        if (webCamAccessState === WebCamState.denied) {
            await this.errorService.webCamDenied();
            return;
        }

        // quality check
        const qualityCheckState = await this.webcamAccessManager.showQualityCheckScreen();

        if (qualityCheckState.state === WebCamState.denied) {
            await this.errorService.noWebCamActivities();
            return;
        }

        if (qualityCheckState.state === WebCamState.failed && qualityCheckState.reason === ErrorReason.face_duplication) {
            await this.errorService.displayFaceDuplicationMessage();
            return;
        }

        // Test...
        this.test.showLoadingMediaScreen();

        await this.test.preload();

        //Init test event handlers
        this.test.startTest();

        // Start recording
        await this.test.startRecording();

        // Play all
        await this.test.playAll();

        // Stop recording
        await this.test.stopRecording();

        //Finish the test
        await this.test.complete();

        // Redirect
        // TODO: move to StandaloneFlow
        this.redirectService.handleSurveyCompleted();
    }
}